export * from './tabs.variants.defaults';
